module.exports = __webpack_public_path__ + "img/honour-pic-2.6ea340df.png";